import React from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const AttachRowSkeleton = () => (
  <Grid item xs={12}>
    <Card>
      <Box width="100%" p={2}>
        <SkeletonBody lines={3} />
      </Box>
    </Card>
  </Grid>
);

export default AttachRowSkeleton;
